"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkPreview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LinkPreviewHead_1 = require("./LinkPreviewHead");
/**
 * A link preview to represent a web page. Renders a page head containing metadata
 * used by preview platforms, e.g. Facebook/Twitter to render previews
 */
function LinkPreview({ linkPreview }) {
    const facebookImage = linkPreview.facebookImage;
    const twitterImage = linkPreview.twitterImage;
    return ((0, jsx_runtime_1.jsx)(LinkPreviewHead_1.LinkPreviewHead, { openGraph: facebookImage && {
            title: linkPreview.title,
            description: linkPreview.description,
            url: linkPreview.canonicalUrl,
            image: facebookImage,
        }, twitter: twitterImage && {
            title: linkPreview.title,
            description: linkPreview.description,
            image: twitterImage,
        } }));
}
exports.LinkPreview = LinkPreview;
//# sourceMappingURL=LinkPreview.js.map